import React from 'react';
import { formatSEK, formatDate } from './formatUtils';

/**
 * InvoiceList — Invoice table with status badges and overdue highlighting.
 */
export default function InvoiceList({ artifact }) {
  const { title, invoices = [], totalAmount } = artifact;
  if (!invoices.length) return null;

  const statusConfig = {
    paid: { label: 'Betald', className: 'finn-badge-paid' },
    unpaid: { label: 'Obetald', className: 'finn-badge-unpaid' },
    overdue: { label: 'Förfallen', className: 'finn-badge-overdue' },
    pending: { label: 'Väntar', className: 'finn-badge-pending' },
  };

  return (
    <div className="finn-artifact finn-invoice-list">
      {title && (
        <div className="finn-artifact-header">
          <span className="finn-artifact-title">{title}</span>
          {totalAmount != null && (
            <span className="finn-artifact-total">Totalt: {formatSEK(totalAmount)}</span>
          )}
        </div>
      )}
      <div className="finn-table-scroll">
        <table>
          <thead>
            <tr>
              <th>Nr</th>
              <th>Motpart</th>
              <th style={{ textAlign: 'right' }}>Belopp</th>
              <th>Förfallodatum</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((inv, i) => {
              const cfg = statusConfig[inv.status] || statusConfig.pending;
              const isOverdue = inv.status === 'overdue';
              return (
                <tr key={inv.id || i} className={isOverdue ? 'finn-row-overdue' : ''}>
                  <td className="finn-num-mono">{inv.number || '—'}</td>
                  <td>{inv.counterpart}</td>
                  <td className="finn-num" style={{ textAlign: 'right' }}>{formatSEK(inv.amount)}</td>
                  <td>{formatDate(inv.dueDate)}</td>
                  <td>
                    <span className={`finn-badge ${cfg.className}`}>
                      {cfg.label}
                      {isOverdue && inv.daysOverdue > 0 && (
                        <span className="finn-badge-days"> ({inv.daysOverdue}d)</span>
                      )}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
